module.exports = __webpack_public_path__ + "img/10.be05cb09.jpg";